<template>
  <b-modal v-bind:id="modId" v-bind:title="titleMsg" hide-footer>
    <p class="my-4">{{ msg }}</p>
    <b-button variant="primary" block @click='clickYes'>{{ yesButtonMsg }}</b-button>
    <b-button block @click='clickNo'>{{ noButtonMsg }}</b-button>
  </b-modal>
 </template>

<script>
export default {
  name: 'Modal',
  props: ['modId', 'titleMsg', 'msg', 'yesButtonMsg', 'noButtonMsg'],
  methods: {
    clickYes: function () {
      this.$parent.modalResult = true
      this.confirmModal()
    },
    clickNo: function () {
      this.$parent.modalResult = false
      this.confirmModal()
    },
    confirmModal () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/YesNoModal.vue